<div class="dialog-header mb-5">
	<div class="dialog-title">
		<h1 class="title mb-1" mat-dialog-title>
			<ng-container *ngIf="dialogSettings.title">{{ dialogSettings.title }}</ng-container>
			<ng-container *ngIf="!dialogSettings.title" i18n="Dialog Title@@dataImportDialogTitle">Import file</ng-container>
		</h1>
		<mat-icon *ngIf="dialogSettings.showDialogCloseButton" [mat-dialog-close]="null" class="cursor-pointer primary-color">close</mat-icon>
	</div>
	<p class="subtitle" *ngIf="dialogSettings.copy">{{ dialogSettings.copy }}</p>
</div>

<div mat-dialog-content class="import-content">
	<div class="drop-area" (click)="fileInput.click()" appDropFile (filesDropped)="selectFile($event)">
		<p class="title mb-0">
			<ng-container *ngIf="dialogSettings.dropAreaTitle">{{ dialogSettings.dropAreaTitle }}</ng-container>
			<ng-container *ngIf="!dialogSettings.dropAreaTitle" i18n="Drop Area Title@@dataImportDialogDropAreaTitle">Choose a file or drag it here to replace the uploaded file</ng-container>
		</p>
		<p class="subtitle mb-0" *ngIf="dialogSettings.dropAreaCopy">{{ dialogSettings.dropAreaCopy }}</p>
		<input
			hidden
			type="file"
			#fileInput
			(change)="selectFile($event.target['files']); fileInput.value = null"
			[accept]="dialogSettings.uploadAccept || '*'"
			[multiple]="dialogSettings.multipleFiles"
			data-testid="templateFileUploadInput"
		/>
	</div>

	<div>
		<div class="file-preview mb-2" *ngFor="let selectedFile of selectedFiles; let i = index">
			<mat-icon>description</mat-icon>
			<div class="file-info">
				<p class="title fw-700 mb-0">{{ selectedFile.file.name }}</p>
				<p class="subtitle mb-0">
					{{ selectedFile.file.lastModified | date: 'long' }} • {{ selectedFile.file.size | filesizeFormat }}
				</p>
			</div>
			<div class="actions">
				<mat-icon color="warn" class="cursor-pointer" (click)="removeFile(i)">delete_outline</mat-icon>
			</div>
		</div>
	</div>

	<!-- Verification -->
	<!--
	<div class="verification">
		<div class="verification-status">
			<mat-icon>loop</mat-icon> <span>Verifying the uploaded file ... </span>
		</div>
		<div class="verification-status">
			<mat-icon>check</mat-icon> <span>Uploaded file has passed verification. You can now import it. </span>
		</div>
		<div class="verification-status error">
			<mat-icon>close</mat-icon> <span>Uploaded file has failed verification. There seems to be a problem with ... error message here.</span>
		</div>
	</div>
	 -->
</div>

<div mat-dialog-actions class="dialog-footer">
	<div class="flex-grow">
		<button *ngIf="dialogSettings.showSecondaryButton" mat-raised-button color="primary" class="submit margin-right-auto">
			{{ dialogSettings.secondaryButtonText }}
		</button>
		<button *ngIf="dialogSettings.showTemplateDownloadButton" mat-raised-button color="primary" class="submit margin-right-auto" (click)="dialogSettings.onDownloadTemplate()">
			<mat-icon>download</mat-icon> <ng-container i18n="Download Template Button@@adminDataImportTemplateDownloadButtonLabel">Template</ng-container>
		</button>
	</div>
	<div>
		<button
			*ngIf="dialogSettings.showCancelButton"
			mat-button
			[mat-dialog-close]="null"
			color="secondary"
			class="submit margin-left-auto secondary-button"
		>
			<ng-container *ngIf="dialogSettings.cancelButtonText">{{ dialogSettings.cancelButtonText }}</ng-container>
			<ng-container *ngIf="!dialogSettings.cancelButtonText" i18n="Cancel Button@@dataImportDialogCancelButtonLabel">Cancel</ng-container>
		</button>

		<button
			[disabled]="submitted"
			mat-raised-button
			[disabled]="!selectedFiles?.length"
			color="primary"
			class="submit margin-right-auto"
			(click)="submit()"
			i18n="Import File@@dataImportDialogImportButtonLabel"
		>
			Import File
		</button>
	</div>
</div>

<div *ngIf="errorMessage">
	<h3 i18n="Error Response Title@@dataImportDialogErrorTitle">Error Response</h3>
	<textarea rows="5" class="error-message" readonly>{{ errorMessage }}</textarea>
</div>
